import styled from "styled-components"
import React from "react"
import {
    CheckIcon,
    SelectDropdown,
    SelectDropdownItem,
} from "client/components"

export const BreadCrumbWrapper = styled.div`
    display: flex;
    width: 100%;
    height: 56px;
    min-height: 56px;
    background: ${(props) => props.theme.driveToolbarBackgroundColor};
    border-bottom: solid 2px ${(props) => props.theme.driveToolbarBorderColor};
`
export const BreadCrumbList = styled.div`
    display: flex;
    flex-grow: 1;
    padding: 0 10px;
`
export const BreadCrumbItem = styled.div`
    display: flex;
    align-items: center;
`
export const BreadCrumbDelimiter = styled.div`
    display: flex;
    padding: 0 8px;

    &:before {
        padding: 0 2px;
        color: #6c757d;
        content: "/";
    }
`


export const ListStyleWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 10px;

    &:before {
        content: "";
        display: block;
        position: absolute;
        height: 32px;
        width: 1px;
        left: 50%;
        top: 50%;
        transform: translateY(-50%);
        background: ${(props) => props.theme.driveToolbarListStyleBorderColor};
    }
`
export const ListStyle = styled.div<{
    left?: boolean
    right?: boolean
    active: boolean
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    width: 50px;
    border: 1px solid ${(props) => props.theme.driveToolbarListStyleBorderColor};

    ${(props) => props.left && `
        border-top-left-radius: 17px;
        border-bottom-left-radius: 17px;
        border-right: none;
    `}
    ${(props) => props.right && `
        border-top-right-radius: 17px;
        border-bottom-right-radius: 17px;
        border-left: none;
    `}
    ${(props) => props.active && `
        background: ${props.theme.driveToolbarListStyleBackground};
    `}
`


export const SortWrapper = styled.div`
    display: flex;
`
export const SortDropdown = styled(SelectDropdown)`
    & > .btn, & > .btn:active, & > .btn:focus, & > .btn:active:focus {
        height: 100%;
        margin: 0;
        padding-right: 28px;
        background: ${(props) => props.theme.driveToolbarBackgroundColor} !important;
    }

    & > .dropdown-menu {
        width: fit-content;
        overflow-y: auto;
    }
`
export const SortDropdownItem = styled(SelectDropdownItem)`
    &.bordered {
        border-top: 1px solid ${(props) => props.theme.driveSortBorderColor};
    }
`


const CheckIconWrapper = styled.div`
    float: right;
    color: ${(props) => props.theme.driveSortReverseColor};
`
export const SortReverse = (props: React.HTMLAttributes<HTMLDivElement>) => (
    <CheckIconWrapper {...props}>
        <CheckIcon />
    </CheckIconWrapper>
)
